import { useNavigate, useLocation } from 'react-router-dom';
import type { GroupedAlert } from '@kirin/api-client/contracts/alerts';
import { AlertDetailContent } from '@/components/grouped-alerts/AlertDetailContent';

interface TableRowExpandedProps {
  row: GroupedAlert;
}

/**
 * Expanded row content for the user alerts DataTable.
 * Matches the legacy AlertsTable expansion exactly:
 * the alert detail panel, whose "Show Instances" navigates to the occurrences route.
 * Preserves URL search params so the DataTable can re-hydrate its state on modal close.
 */
export function TableRowExpanded({ row }: TableRowExpandedProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const occurrencesPathname = `/dashboard/alerts/${encodeURIComponent(row.alertKey)}/occurrences`;

  return (
    <div className="min-w-0 max-w-full">
      <AlertDetailContent
        alert={row}
        scope={{ kind: 'account' }}
        alertKey={row.alertKey}
        onShowOccurrences={() =>
          navigate({ pathname: occurrencesPathname, search: location.search })
        }
      />
    </div>
  );
}
